// SetupDatesStep — valuation/grant date alignment (F9.3). Builder step 1.

import { useActiveValuation, useStore } from '../../store/selectors';
import { Field } from '../common/Field';

export function SetupDatesStep() {
  const active = useActiveValuation();
  const setCompliance = useStore((s) => s.setCompliance);
  if (!active) return null;
  const c = active.inputs.compliance;
  const stale =
    active.inputs.compliance.grantDate &&
    active.inputs.compliance.valuationDate &&
    active.inputs.compliance.grantDate > active.inputs.compliance.valuationDate
      ? Math.round(
          (new Date(active.inputs.compliance.grantDate).getTime() -
            new Date(active.inputs.compliance.valuationDate).getTime()) /
            86400000,
        )
      : null;

  return (
    <div className="card">
      <div className="card-title">Setup &amp; Dates</div>
      <div className="headline-grid">
        <Field
          label="Valuation Date"
          htmlFor="valuationDate"
          helpText="The as-of date the FMV is determined for. The safe-harbor window and refresh-reminder timers run from this date."
        >
          <input
            id="valuationDate"
            className="input"
            type="date"
            value={c.valuationDate}
            onChange={(e) => setCompliance(active.valuationId, { valuationDate: e.target.value })}
          />
        </Field>
        <Field
          label="Grant Date"
          htmlFor="grantDate"
          hint="Intended option grant date"
          helpText="Planned option grant date. Grants later than 12 months after the valuation date are flagged GRANT_DATE_STALE."
        >
          <input
            id="grantDate"
            className="input"
            type="date"
            value={c.grantDate ?? ''}
            onChange={(e) =>
              setCompliance(active.valuationId, { grantDate: e.target.value || null })
            }
          />
        </Field>
        <Field
          label="Safe Harbor"
          htmlFor="safeHarbor"
          helpText="Independent Appraisal = strongest presumption (§409A-1(h)(1)(C)). Illiquid Startup = formula safe harbor. Binding Formula = 90-day non-repudiation. None = FMV fully challengeable."
        >
          <select
            id="safeHarbor"
            className="select"
            value={c.safeHarbor}
            onChange={(e) =>
              setCompliance(active.valuationId, { safeHarbor: e.target.value as typeof c.safeHarbor })
            }
          >
            <option value="none">None</option>
            <option value="illiquidStartup">Illiquid Startup</option>
            <option value="bindingFormula">Binding Formula</option>
            <option value="independentAppraisal">Independent Appraisal</option>
          </select>
        </Field>
      </div>
      {stale !== null && stale > 365 && (
        <p className="badge badge-warning mt-3">
          Grant date is {stale} days after valuation (&gt; 12 months) — GRANT_DATE_STALE
        </p>
      )}
    </div>
  );
}
